<div class="wrapper">
  <h1>404</h1>
  <h3>Page Not Found</h3>
</div>